<app-toolbar>
  <app-breadcrumbs></app-breadcrumbs>
  <app-page-search class="me-auto" [(searchString)]="filter.Global" (searchStringChange)="search$.next($event)" [(showFilters)]="filter.AdvancedFilter"></app-page-search>
  <app-toolbar-list-buttons (addClick)="goToAdd()" *transloco="let t; read: 'ime.components.action-bar'">
    <div ngbDropdown class="d-inline-block">
      <button type="button" class="btn btn-sm btn-outline-primary me-1" ngbDropdownToggle>
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#table-cells'">
        </svg>
        {{t('Export')}}
      </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem (click)="saveExcel('DownloadExcelAllData')">{{t('All data with IME tab')}}</button>
        <button ngbDropdownItem (click)="saveExcel('DownloadExcel')">{{t('All data without IME tab')}}</button>
        <button ngbDropdownItem (click)="saveExcel('DownloadCompactExcel')">{{t('Visible columns')}}</button>
      </div>
    </div>
  </app-toolbar-list-buttons>
</app-toolbar>
<app-item-table [stateKey]="stateKey"
                [filter]="filter"
                [defaultFilter]="defaultFilter"
                [search$]="search$"
                [rowSelectEnabled]="rowSelectEnabled"
                [urlForEdit]="urlForEdit"
                (filterChanged)="runChangeDetector()"
                (onSelect)="openEditByItem($event)"/>
